import { push } from 'redux-first-history';
import type { SessionId } from '../../domain/Session';
import { sessionIdQuery } from '../../streetViewer/queries';
import { createCommand } from '../../utils';
import { moduleName, lastOpenedSessionIdIsSet } from '../state';

const getStreetviewUrl = (sessionId: string, cumul: number | null, imageId?: string): string => {
    let route = `/acquisition/street-view/${sessionId}`;
    if (imageId && cumul !== null) {
        throw new Error('Cannot use both imageId and cumul simultaneously');
    }
    if (imageId) {
        route += `?imageId=${imageId}`;
    }
    if (cumul) {
        route += `?cumul=${cumul}`;
    }

    return route;
};

export type Args = {
    sessionId: SessionId;
    cumul?: number;
    imageId?: string;
};

export const NavigateToSessionStreetviewCommand = createCommand(
    `${moduleName}/NAVIGATE_TO_SESSION_STREET_VIEW_ON_SPECIFIC_CUMUL`,
    async ({ sessionId, cumul, imageId }: Args, { dispatch, getState }) => {
        const currentSessionIdInStreetview = sessionIdQuery(getState());
        if (!currentSessionIdInStreetview || currentSessionIdInStreetview !== sessionId) {
            await dispatch(lastOpenedSessionIdIsSet(sessionId));
        }
        const route = getStreetviewUrl(sessionId, cumul ?? null, imageId);

        await dispatch(push(route));
    },
);
